import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from 'ctsutheme';
import { createGenerateClassName, jssPreset } from '@material-ui/styles';
import { Loader } from '@ctsu/loader';
import { indexRoutes } from 'routes/appRoutes';
import configureStore, { history } from 'stores/store';
import { create } from 'jss';
import { ConnectedRouter } from 'connected-react-router';
import Layout from 'components/Layout';
import { RSSDialogContainer } from 'containers/modal';
import Notifier from 'helpers/Notifier';
import Confirmation from 'helpers/Confirmation';
import PopOver from 'helpers/PopOver';
import { Loading } from 'components';
import { JssProvider } from 'react-jss';
import rtl from 'jss-rtl';

import AppRoutesSwitch from 'components/AppRoutesSwitch';

export default function App() {
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const generateClassName = createGenerateClassName();
  
 

  return (
    <JssProvider jss={jss} generateClassName={generateClassName} classNamePrefix="protocol-app-">
      <Suspense
        fallback={
          <main>
            <Loading />
          </main>
        }
      >
        <MuiThemeProvider theme={theme}>
          <Provider store={configureStore()}>
            <ConnectedRouter history={history}>
              <Loader loadIndicator={<Loading />}>
                <Notifier />
                <Confirmation />
                <PopOver />
                <RSSDialogContainer />
                <Layout>
                  <AppRoutesSwitch routes={indexRoutes} />
                </Layout>
              </Loader>
            </ConnectedRouter>
          </Provider>
        </MuiThemeProvider>
      </Suspense>
    </JssProvider>
  );
} 
